(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          var iframes = document.querySelectorAll('.iframe');

          iframes.forEach(function (iframe, index) {
            if (iframe.isLoaded) {
              return;
            }

            iframe.addEventListener('load', function () {
              iFrameResize({ log: false }, '#' + iframe.id);
              iframe.isLoaded = true; // track that this iframe has been loaded
            });

            // Manually trigger the resize
            iFrameResize({ log: false }, '#' + iframe.id);
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // This will track iframe removals to reset the isLoaded flag
    document.body.addEventListener('DOMNodeRemoved', function (event) {
      var iframe = event.target;
      if (iframe.tagName === 'IFRAME' && iframe.classList.contains('iframe')) {
        iframe.isLoaded = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
